export default __webpack_public_path__ + "static/media/bg_card_ms.5875c439.svg";